const TOKEN_REGEX = /[@A-Za-z0-9][@A-Za-z0-9._'-]*/g;

const TEXT_BLOCKED_PREFIXES = [
  'asshole',
  'bastard',
  'bitch',
  'boob',
  'cock',
  'cunt',
  'dick',
  'dildo',
  'fag',
  'fuck',
  'horny',
  'motherfuck',
  'nigg',
  'penis',
  'pussy',
  'titty',
  'tits',
  'vagin',
];

const TEXT_BLOCKED_EXACT = new Set([
  'anal',
  'blowjob',
  'cum',
  'handjob',
  'jizz',
  'milf',
  'nude',
  'nudes',
  'orgasm',
  'porn',
  'porno',
  'rape',
  'rapist',
  'sex',
  'sexy',
  'slut',
  'whore',
  'xxx',
]);

const USERNAME_BLOCKED_FRAGMENTS = [
  'anal',
  'asshole',
  'bastard',
  'bitch',
  'blowjob',
  'boob',
  'cock',
  'cunt',
  'cum',
  'dick',
  'dildo',
  'fag',
  'fuck',
  'handjob',
  'horny',
  'jizz',
  'milf',
  'motherfuck',
  'nigg',
  'nude',
  'orgasm',
  'penis',
  'porn',
  'porno',
  'pussy',
  'rape',
  'rapist',
  'sexy',
  'slut',
  'titty',
  'tits',
  'vagin',
  'whore',
  'xxx',
];

const PHRASE_PATTERNS = [
  /\bblow[\W_]*job\b/gi,
  /\bhand[\W_]*job\b/gi,
  /\bsuck[\W_]*my[\W_]*dick\b/gi,
];

const normalizeForModeration = (value: string) => value.toLowerCase().replace(/[^a-z0-9]/g, '');

const maskMatch = (value: string) => value.replace(/[A-Za-z0-9]/g, '*');

const shouldCensorToken = (normalized: string) => {
  if (!normalized) return false;
  if (TEXT_BLOCKED_EXACT.has(normalized)) return true;
  return TEXT_BLOCKED_PREFIXES.some(prefix => normalized.startsWith(prefix));
};

export const censorInappropriateText = (value: string) => {
  if (!value) return value;

  let censored = value;
  for (const pattern of PHRASE_PATTERNS) {
    censored = censored.replace(pattern, maskMatch);
  }

  return censored.replace(TOKEN_REGEX, (token) => {
    const leadingAt = token.startsWith('@') ? '@' : '';
    const body = leadingAt ? token.slice(1) : token;
    const normalized = normalizeForModeration(body);

    if (!shouldCensorToken(normalized)) return token;
    return leadingAt + maskMatch(body);
  });
};

export const hasInappropriateUsername = (value: string) => {
  const normalized = normalizeForModeration(value);
  if (!normalized) return false;
  return USERNAME_BLOCKED_FRAGMENTS.some(fragment => normalized.includes(fragment));
};

// Letters, numbers, underscore, and period only.
const USERNAME_CHARSET_REGEX = /^[A-Za-z0-9_.]+$/;
export const USERNAME_MAX_LENGTH = 25;

export const isValidUsernameFormat = (value: string) => USERNAME_CHARSET_REGEX.test(value) && value.length <= USERNAME_MAX_LENGTH;

// For live-typing filters: strips any character outside the allowed set,
// lowercases (usernames are always stored/displayed lowercase, so the input
// reflects that as you type instead of surprising you at save time), and
// caps the length so it can be assigned straight to a controlled input.
export const sanitizeUsernameInput = (value: string) => value.replace(/[^A-Za-z0-9_.]/g, '').slice(0, USERNAME_MAX_LENGTH).toLowerCase();
